export default {
  init() {
    // JavaScript to be fired on the about us page
  },
  finalize() {
    const form = document.querySelector('form.business-search-form');
    if (form) {
      const base_path    = 'business-directory';
      const base_url     = `${location.protocol}//${location.host}/`;
      const filterSelect = form.querySelector('#filter-select');
      const input        = form.querySelector('#search-input');


      form.addEventListener('submit', event => {
        event.preventDefault();
        if(input.value) {
          location.href = `${base_url}${base_path}/?post_type=business&s=${input.value}`;
        }
      });

      filterSelect.addEventListener('change', event => {
        if(event.target.value) {
          location.href = `${base_url}/business-category/${event.target.value}/`;
        } else {
          location.href = `${base_url}${base_path}`;
        }
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/taxonomyBusinessCategory.js